import api from '../../../../api/client'

export async function listCurrencies() {
  const { data } = await api.get('/currencies/')
  return Array.isArray(data) ? data : []
}

export async function getCurrencyDetail(currencyCode) {
  const { data } = await api.get(`/currencies/${currencyCode}`)
  return data
}

export async function createCurrency(payload) {
  const { data } = await api.post('/currencies/', payload)
  return data
}

export async function updateCurrency(currencyCode, payload) {
  const { data } = await api.put(`/currencies/${currencyCode}`, payload)
  return data
}

export async function updateExchangeRate(payload) {
  const { data } = await api.put('/currencies/rate', payload)
  return data
}

export async function deleteCurrency(currencyCode) {
  const { data } = await api.delete(`/currencies/${currencyCode}`)
  return data
}
